import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getCustomHtmlInstructionUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.ws-helpcenter.custom_html_instruction_url');
  }

  return get(cfg, 'common.ws-helpcenter.custom_html_instruction_wl_url');
};

export default getCustomHtmlInstructionUrl;
